import { useEffect } from 'react'

import { usePersistentObservatoryPageStore } from '@/feature/observatory'

export const useEtaMapInitialization = (): void => {
  const toggleAssets = usePersistentObservatoryPageStore((state) => state.toggles.setAssets)
  const toggleGeoFences = usePersistentObservatoryPageStore((state) => state.toggles.setGeoFences)

  useEffect(() => {
    // Hide assets/geofences while the ETA panel is open. The camera is intentionally left where it
    // is (on the asset the user selected) — useEtaCalculation animates a single smooth zoom-out to
    // fit the asset, route path and geofence once the route resolves, avoiding a jarring snap.
    toggleAssets(false)
    toggleGeoFences(false)

    return () => {
      toggleAssets(true)
      toggleGeoFences(true)
    }
  }, [])
}

